import React, { useEffect, useState } from "react";
import { Container } from "react-bootstrap";
import Blogimg1 from "../../assets/images/blogZHimg1.webp";
import Blogimg2 from "../../assets/images/blogZHimg2.webp";
import Blogimg3 from "../../assets/images/blogZHimg3.webp";

export const BlogZeroHero = ({ counter }) => {
  return (
    <div className="blog-bg1 py-5">
      <Container style={{ overflow: "hidden" }}>
        <div className="row">
          <div className="d-flex flex-column flex-lg-row p-lg-3 mt-3">
            <div
              className="col-12 col-md-12 col-lg-6 pb-4"
              data-aos="fade-right"
            >
              <div className="px-lg-3">
                {/* <h5 className="text-start">"From Zero To Hero"</h5> */}
                <h5 className="text-start">"Transforming Lives with the Clothing Business"</h5>
              </div>
              <div className="d-flex flex-column flex-md-row justify-content-start align-items-center gap-2 px-lg-3">
                <div className="d-flex flex-column gap-2">
                   {/* old */}
                  {/* <p className="mb-0 fs-20 fs-sm-14">
                    Kesaria Textile Company is a renowned Surat-based saree
                    manufacturer. Since its establishment in 1977, the
                    organization has achieved significant and continuous growth
                    within the business by delivering products that meet
                    customers' needs. We tend to export to 80+ countries across
                    the globe.
                  </p> */}
                  <p className="mb-0 fs-20 fs-sm-14">
                    In today’s world, success is not just about finding the right opportunity it’s about taking action at the right time. At Kesaria Textile Company, we have been empowering individuals, startups, and entrepreneurs since 1977, turning their dreams into reality through the power of the clothing business.
                  </p>
                  <p className="mb-0 fw-bold fs-20 fs-sm-14">
                    From a Small Step to a Giant Leap
                  </p>
                  {/* old */}
                  {/* <p className="mb-0 fs-20 fs-sm-14">
                    Kesaria Textile Company is a manufacturer, wholesaler, and
                    exporter of sarees and women’s clothing wear. We have a
                    manufacturing capacity of more than one million pieces per
                    month. Since the beginning, our company has been dedicated
                    to customer satisfaction and we have put all our efforts
                    into it. Clients are most valuable to us, and they are
                    playing a major role in our success and accomplishment.
                  </p> */}
                  <p className="mb-0 fs-20 fs-sm-14">
                    The textile industry has always been a goldmine for those who dare to dream big. Whether you are a small retailer, a first-time entrepreneur, or someone looking for financial independence, the clothing business offers limitless opportunities. Our journey from Surat to exporting in 80+ countries is a testament to the fact that passion, quality products, and the right support system can take you from zero to hero.
                  </p>
                  {/* <p className="mb-0 fw-bold fs-20 fs-sm-14">
                    A Business That Grows With You
                  </p>
                  <p className="mb-0 fs-20 fs-sm-14">
                    The beauty of the textile business lies in its scalability. You don’t need a massive investment to start. With Kesaria Textile Company’s wholesale pricing, diverse collections, and industry-leading quality, anyone can step into the fashion business and grow. Many of our clients started with a small shop and now run multi-city businesses.
                  </p> */}
                  {/* <p className="mb-0 fw-bold fs-20 fs-sm-14">
                    Why Choose Kesaria?
                  </p>
                  <p className="mb-0 fs-20 fs-sm-14">
                    ✅ Support for New Entrepreneurs
                    <br />
                    ✅ 1 Million+ Sarees Per Month
                    <br />
                    ✅ Global Market Access
                    <br />
                    ✅ Affordable Pricing, Maximum Profits
                  </p> */}
                  {/* <p className="mb-0 fs-20 fs-sm-14">
                    Join the Next Generation of Fashion Entrepreneurs!
                  </p>
                  <p className="mb-0 fs-20 fs-sm-14">
                    The next revolution in the clothing industry is here. If you’ve ever dreamed of running your own business, now is the time to take that leap. With Kesaria Textile Company, your success is not just a possibility—it’s a promise.
                  </p>
                  <p className="mb-0 fw-bold fs-20 fs-sm-14">
                    🚀 Start your journey today and become the next success story!
                  </p>
                  <p className="mb-0 fw-bold fs-20 fs-sm-14">
                    📩 Contact us to explore business opportunities with Kesaria Textile Company.
                  </p> */}
                  {/* <img src={Blogimg3} alt="blog3" style={{ width: "15%" }} /> */}
                </div>
              </div>
            </div>
            <div className="col-12 col-md-12 col-lg-6 mt-3 mt-md-0  mb-5 mb-md-0 animationmove d-flex justify-content-end">
              <div style={{ position: "relative" }}>
                <img
                  src={Blogimg1}
                  alt="blog-main-image"
                  className="blog-main-image them-borderradius"
                />
                <div className="blog-redimage"></div>
                <div className="bg-danger d-flex flex-column justify-content-center align-items-center blog-secon-div animationmove">
                  <img alt="blog image" className="img-fluid py-1" src={Blogimg2} />
                  <div className="blog-zh-p1 py-1">{counter}+</div>
                  <p className="blog-zh-p2">Started With Kesaria</p>
                </div>
              </div>
            </div>
          </div>
        </div>
      </Container>
    </div>
  );
};
